<template>
    <v-card tile class="nav-bar">
        <v-toolbar dark>
            <template v-for="(item, index) in items">
                <v-btn text class="nav-btn" :style="{ width: `${100 / items.length}%` }" :to="item.to" :key="item.to">
                    <div class="d-flex flex-column align-center">
                        <v-icon>{{ item.icon }}</v-icon>
                        <span class="text-caption">{{ item.text }}</span>
                    </div>
                </v-btn>
                <v-divider vertical v-if="index < items.length - 1" :key="index"></v-divider>
            </template>
        </v-toolbar>
    </v-card>
</template>

<script>
    export default {
        props: {
            items: {
                type: Array,
                default: () => []
            }
        }
    };
</script>

<style lang="scss" scoped>
    ::v-deep .v-toolbar__content {
        padding: 0;
    }
    .nav-bar {
        z-index: 9999;
    }
    .nav-btn {
        height: 100% !important;
        border-radius: 0;
    }
</style>
